import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function AlertDialog({open, accept, decline, title, text, acceptText, declineText}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={decline}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={decline}>{declineText}</Button>
          <Button onClick={accept} autoFocus>{acceptText}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export {AlertDialog}